import { useMemo } from 'react';
import { FileTypeFilter } from '@streamloots/streamloots-types';
import { PageFeed, PageFeedEmbedInfo } from 'model/indexTS';
import { TranslateInterface } from 'utils/translation';
import IframeWrapper from 'components/iframe-wrapper';
import Render from 'components/render';
import { PageFeedEmbedController } from 'domain/page-feed-embed-controller';
import { isOfType } from 'types/indexTS';
import { EmbedAttachment } from '../embedded-attachments/EmbedAttachment';
import { FeedAttachmentsImage } from './FeedAttachmentsImage';

export interface FeedAttachmentsProps extends TranslateInterface {
  feed: PageFeed;
}

export const FeedAttachments = ({ feed, t }: FeedAttachmentsProps): JSX.Element | null => {
  const normalizedAttachments = useMemo(() => {
    const embedAttachment = feed.attachments.find(
      attachment =>
        attachment.type === FileTypeFilter.VIDEOS && PageFeedEmbedController.getNetworkToEmbed(attachment.url),
    );

    if (embedAttachment) {
      return PageFeedEmbedController.getNetworkToEmbed(embedAttachment.url);
    }

    return {
      urls: feed.attachments.map(attachment => attachment.url),
      isVideo: feed.attachments.some(attachment => attachment.type === FileTypeFilter.VIDEOS),
    };
  }, [feed.attachments]);

  if (!normalizedAttachments) {
    return null;
  }

  if (isOfType<PageFeedEmbedInfo>(normalizedAttachments, 'network')) {
    return (
      <Render.Client>
        <EmbedAttachment embedAttachment={normalizedAttachments} />
      </Render.Client>
    );
  }

  if (normalizedAttachments.urls.length <= 0) {
    return null;
  }

  return (
    <>
      {normalizedAttachments.isVideo ? (
        <IframeWrapper url={normalizedAttachments.urls[0]} />
      ) : (
        <FeedAttachmentsImage feed={feed} t={t} />
      )}
    </>
  );
};
